
namespace Matrix.Scheduling {

    @Serenity.Decorators.registerEditor()
    @Serenity.Decorators.element("<div/>")
    export class CalendarEntryGrid extends SiteEntityGrid<CalendarEntryRow, any> {
        protected getColumnsKey() { return 'Scheduling.CalendarEntry'; }
        protected getDialogType() { return CalendarEntryDialog; }
        protected getIdProperty() { return CalendarEntryRow.idProperty; }
        protected getInsertPermission() { return CalendarEntryRow.insertPermission; }
        protected getLocalTextPrefix() { return CalendarEntryRow.localTextPrefix; }
        protected getService() { return CalendarEntryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        private _calendarCode: string;

        public set calendarCode(value: string) {
            if (this._calendarCode !== value) {
                this._calendarCode = value;
                this.setEquality(CalendarEntryRow.Fields.CalendarCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<CalendarEntryRow>{
                CalendarCode: this._calendarCode
            });
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._calendarCode;
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._calendarCode);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }

    }
}